module.exports = __webpack_public_path__ + "img/story021@2x.c855258f.png";